import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  INewPasswordPersonelInfoRequest,
  IPasswordPersonelInfo,
  IPasswordCardInfoRequest,
  IPasswordCardInfo,
} from "models/Password/password.model";
import {
  PasswordRefresh_cardInfo,
  PasswordRefresh_personelInfo,
} from "services/password/password.service";

export const PasswordRefreshPersonelInfoAsync = createAsyncThunk(
  "passwordRefresh",
  async (
    passPersonelInfoReq: INewPasswordPersonelInfoRequest
  ): Promise<IPasswordPersonelInfo> => {
    try {
      const response = await PasswordRefresh_personelInfo(passPersonelInfoReq);
      return response;
    } catch (error: any) {
      throw error;
    }
  }
);

export const PasswordRefreshCardInfoAsync = createAsyncThunk(
  "passRefCardInfo",
  async (
    passCardInfoReq: IPasswordCardInfoRequest
  ): Promise<IPasswordCardInfo> => {
    try {
      const response = await PasswordRefresh_cardInfo(passCardInfoReq);
      return response;
    } catch (error: any) {
      throw error;
    }
  }
);
